// ** Icon Imports
import React from "react";
import { Icon } from "@iconify/react";

const IconifyIcon = ({ icon, fontSize = "1.375rem", ...rest }) => {
  return <Icon icon={icon} fontSize={fontSize} {...rest} />;
};

export default IconifyIcon;
